import { Prisma } from "@prisma/client";
import { fileSelectValues } from "./file.types";

export const structureDocumentTypeValues =
  Prisma.validator<Prisma.StructureDocumentDefaultArgs>()({
    select: {
      id: true,
      structureId: true,
      name: true,
      link: true,
      createdAt: true,
      updatedAt: true,
      file: {
        select: fileSelectValues,
      },
      thumbnail: {
        select: fileSelectValues,
      },
      eventDocuments: {
        select: {
          eventStructure: {
            select: {
              eventId: true,
            },
          },
        },
      },
    },
  });

export type StructureDocumentType = Prisma.StructureDocumentGetPayload<
  typeof structureDocumentTypeValues
>;

export type StructureDocumentPdfType = StructureDocumentType & {
  file: NonNullable<StructureDocumentType["file"]>;
  link: null;
};

export type StructureDocumentLinkType = StructureDocumentType & {
  link: string;
  file: null;
};
